import type { CSSProperties } from "react";

/** Default max width for auto-sized table columns (px). */
export const TABLE_COLUMN_MAX_WIDTH_PX = 215;

/**
 * Featured-icon gutter: 20px + 32px FeaturedIcon (sm) + 20px.
 * Matches Destiny body-cell horizontal padding (px-5) on both sides.
 */
export const TABLE_ICON_GUTTER_WIDTH_PX = 72;

/** Leading selection gutter: 32px + control + 4px (Figma SelectionCell, w-52). */
export const TABLE_SELECTION_GUTTER_WIDTH_PX = 52;

export interface TableColumnLayoutStyleOptions {
	/** True when the user has resized this column (max-width lifted). */
	isManuallyResized: boolean;
	/** Pixel width from TanStack sizing — only applied when manually resized. */
	sizePx?: number;
	/** Pin width (icon gutter) even when not manually resized. */
	forceSize?: boolean;
}

/**
 * Column layout for CustomTable headers/cells.
 *
 * Default: `width: auto` with `maxWidth: 215px`.
 * After user resize (or forceSize): explicit pixel width, no max-width.
 * Manage Columns → Reset clears manual sizes (and sorting) and restores this default.
 */
export function getTableColumnLayoutStyle({
	isManuallyResized,
	sizePx,
	forceSize = false,
}: TableColumnLayoutStyleOptions): CSSProperties {
	if ((forceSize || isManuallyResized) && sizePx != null && sizePx > 0) {
		return {
			width: sizePx,
			minWidth: sizePx,
			maxWidth: sizePx,
		};
	}

	return {
		width: "auto",
		maxWidth: TABLE_COLUMN_MAX_WIDTH_PX,
	};
}
